import { useState } from "react";
import { GiSpades } from "react-icons/gi";
import { socket } from "../../api";
import { parseJWT } from "../../utils/jwtUtils";

export default function JoinPrivateGame() {
  const [roomCode, setRoomCode] = useState("");

  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  const userInfo = parseJWT(token?.token);

  const handleJoin = () => {
    if (!roomCode) return alert("Enter game code");

    socket.emit("join-by-code", {
      roomCode,
      phone: userInfo.phone,
      name: "Player",
    });
  };

  return (
    <div className="w-full max-w-md mx-auto bg-[#134454] rounded-xl shadow-2xl overflow-hidden border border-[#185163]">
      {/* Header */}
      <div className="bg-gradient-to-l from-cyan-900 via-cyan-800 to-cyan-900 px-5 py-4 flex items-center gap-3">
        <GiSpades className="text-white text-lg animate-pulse" />
        <h2 className="font-semibold text-white text-lg font-serif">
          Join Private Game
        </h2>
      </div>

      {/* Body */}
      <div className="p-4 flex gap-2 md:gap-3">
        <input
          type="text"
          value={roomCode}
          onChange={(e) => setRoomCode(e.target.value)}
          placeholder="Enter game code"
          className="flex-1 md:px-4 px-2 py-3 rounded-lg bg-[#0c3745] text-white border border-[#185163] focus:outline-none focus:ring-2 focus:ring-cyan-600 placeholder-gray-400"
        />

        <button
          onClick={handleJoin}
          className="px-5 rounded-lg bg-gradient-to-r from-primary to-[#6784a4] hover:opacity-90 text-white font-semibold flex items-center gap-2 shadow-lg transition"
        >
          <GiSpades />
          Join
        </button>
      </div>
    </div>
  );
}
